export default __webpack_public_path__ + "static/media/Raider's Boots of a Hundred Eyes.8be24fdd.jpg";